import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../constants';

export const useServiceFormModalStyles = makeStyles((theme) => ({
  subtitle: {
    color: COLORS.muted,
    marginTop: theme.spacing(0.5),
  },
  formGrid: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: '1fr 1fr',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  fullRow: {
    gridColumn: '1 / -1',
  },
  sectionLabel: {
    fontWeight: 600,
    color: COLORS.body,
    marginTop: theme.spacing(1),
  },
  systemRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  metadataRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  metadataKey: {
    flex: 1,
  },
  metadataValue: {
    flex: 2,
  },
  error: {
    color: '#b00020',
    marginTop: theme.spacing(1),
  },
  immutableHint: {
    color: COLORS.muted,
    fontSize: '0.75rem',
  },
  counter: {
    color: COLORS.muted,
    fontSize: '0.75rem',
    textAlign: 'right',
    marginTop: theme.spacing(0.5),
  },
}));
